import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let current_location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })
  return {
    variables: { current_location_id },
  }
}
